export default new class clientSliderComponent {
  constructor() {
    this.clientSliderClass = '_customers-slider';

    this.init();
  }

  init() {
    $(`.${this.clientSliderClass}`).owlCarousel({
      margin: 10,
      loop: false,
      nav: false,
      dots: true,
      responsive: {
        0: {
          items: 1,
        },
        400: {
          items: 1,
        },
        600: {
          items: 3,
        },
        992: {
          items: 3,
        },
        1200: {
          items: 4,
        },
        1600: {
          items: 4,
        },
      },
    });
  }
}();
